import React, { useState } from "react";
import { Browser } from '@capacitor/browser';

// Importar la imagen
import imagen2 from '../assets/imagen2.jpg';

// URL del manual PDF - Actualizar esta constante cuando se tenga un nuevo enlace
const MANUAL_PDF_URL = 'https://drive.google.com/file/d/1gKOWR0f917xYR979qSOUMkDB1Dshqi20/view?usp=sharing';


export default function Home() {
  return (
    <div style={{
      background: '#000000',
      minHeight: '100vh',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '24px'
    }}>
      <div style={{
        width: '100%',
        maxWidth: 800,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 24
      }}>

        {imagen2 ? (
          <img 
            src={imagen2} 
            alt="Imagen principal Honeypress"
            style={{
              width: '90%',
              maxWidth: 480,
              borderRadius: 18,
              marginBottom: 28,
              boxShadow: '0 4px 32px 2px rgba(0,0,0,0.45), 0 2px 10px 0 rgba(255,179,0,0.10)'
            }}
            onError={(e) => {
              console.error('Error al cargar la imagen:', e);
              e.target.style.display = 'none';
            }}
          />
        ) : (
          <div style={{
            width: '90%',
            maxWidth: 480,
            height: 320,
            borderRadius: 18,
            marginBottom: 28,
            backgroundColor: '#1a1a1a',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#666',
            fontSize: '1.1em',
            boxShadow: '0 4px 32px 2px rgba(0,0,0,0.45), 0 2px 10px 0 rgba(255,179,0,0.10)'
          }}>
            Imagen no disponible
          </div>
        )}
        <h1 className="page-title">Bienvenido a Honeypress® App</h1>
        <p style={{color:'#fff',fontWeight:500,fontSize:'1.15em',maxWidth:520,textAlign:'center'}}>Gracias por comprar tu equipo con nosotros y formar parte de la Honeyfamily. Somos líderes en innovación de prensas hidráulicas de calentamiento dual para extracciones. Te invitamos a conocer todas las aplicaciones integradas en nuestra app. Te recordamos que esta aplicación no recopila datos y funciona OFFLINE. Aquí podrás ajustar variables para diferentes resultados, registrar tus extracciones ¡y mucho más!</p>
        <button
          onClick={async () => {
            try {
              await Browser.open({
                url: MANUAL_PDF_URL,
                windowName: '_blank',
                presentationStyle: 'fullscreen'
              });
            } catch (e) {
              console.error('Error al abrir el navegador:', e);
              alert('No se pudo abrir el navegador externo. Por favor, intenta abrir el enlace manualmente.');
            }
          }}
          style={{
            display: 'inline-block',
            marginTop: 12,
            marginBottom: 28,
            padding: '16px 32px',
            background: '#ffb300',
            color: '#fff',
            fontWeight: 700,
            fontSize: '1.18em',
            border: 'none',
            borderRadius: 12,
            textDecoration: 'none',
            boxShadow: '0 2px 12px #ffe0b2',
            letterSpacing: '.02em',
            cursor: 'pointer',
            transition: 'transform 0.2s ease',
            '&:hover': {
              transform: 'scale(1.02)',
              boxShadow: '0 4px 16px #ffe0b2'
            }
          }}
        >
          Descargar Manual PDF
        </button>
      </div>
    </div>
  );
}

const tabStyle = {
  display:'inline-block',
  minWidth:110,
  padding:'22px 18px',
  background:'#fff3e0',
  color:'#e65100',
  borderRadius:'32px',
  boxShadow:'0 2px 12px #ffe0b2',
  fontWeight:700,
  fontSize:'1.08em',
  textAlign:'center',
  textDecoration:'none',
  transition:'transform 0.15s,box-shadow 0.15s',
  margin:'0 2px',
  cursor:'pointer',
  outline:'none',
  border:'2px solid #ffe0b2',
  position:'relative',
};
